export default __webpack_public_path__ + "531c2fbfbd7cba6a1b022d83a726a206.webp";